<app-header></app-header>
<app-home></app-home>
<div class="container-fluid" style="overflow-x: inherit">
  <div class="card jh-card">
    <router-outlet></router-outlet>
  </div>
</div>

<app-footer></app-footer>
